import React, { useRef } from "react"
import { toggleModal } from "components/Stacker/actions/ModalActions"
import ModalConfig from "components/Stacker/config/ModalConfig"
import BreakPointConfig from "components/Stacker/constants/breakpoints"
import { useDispatch } from "react-redux"
import MediaQuery from "react-responsive"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import { NextArrow, PreviousArrow } from "../../Common/Arrows/Arrows"
import Video from "../../Common/IntroCarousel/IntroCarouselVideo"
import "./IntroCarousel.scss"

function IntroCarousel(props) {
  const dispatch = useDispatch()
  const sliderRef = useRef()
  const onNextClick = () => {
    sliderRef.current.slickNext()
  }

  const onStartStackClick = () => {
    dispatch(toggleModal(ModalConfig.MODAL_STACKER_HELP, false))
  }

  const sliderSettings = {
    cssEase: "ease-in-out",
    dots: true,
    infinite: true,
    lazyLoad: true,
    nextArrow: <NextArrow />,
    prevArrow: <PreviousArrow />,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  return (
    <div className="d-flex h-100 w-100 justify-content-between">
      <Slider ref={sliderRef} className="slider w-100" {...sliderSettings}>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678852136" h="cf8f396194" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>STEP1 / SELECT YOUR BRACELETS</span>
                <p>Choose your favorite styles for layering.</p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 1</span>
                <h5>SELECT YOUR BRACELETS</h5>
                <p>Choose your favorite styles for layering.</p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onNextClick}
                >
                  Next
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678852215" h="bf8a41039a" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>STEP 2 / MOVE &amp; MIX</span>
                <p>
                  Create the perfect combination by clicking or tapping a
                  bracelet to move it higher or lower in your stack.
                </p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 2</span>
                <h5>MOVE &amp; MIX</h5>
                <p>
                  Create the perfect combination by clicking or tapping a
                  bracelet to move it higher or lower in your stack.
                </p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onNextClick}
                >
                  Next
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678852339" h="f53f2fb533" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>STEP 3 / EDIT YOUR STACK</span>
                <p>Tap or click “x” to remove a bracelet.</p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 3</span>
                <h5>EDIT YOUR STACK</h5>
                <p>Tap or click “x” to remove a bracelet.</p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onNextClick}
                >
                  Next
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
        <div className="slide-container d-flex w-100 h-100">
          <div className="video-responsive">
            <Video id="678852412" h="2cf323b301" />
          </div>
          <div className="slide-copy-container">
            <div className="slide-copy text-center">
              <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                <span>STEP 4 / FINISH &amp; REVIEW</span>
                <p>
                  Tap or click Review Your Selection when your perfect stack is
                  complete.
                </p>
              </MediaQuery>
              <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                <span>STEP 4</span>
                <h5>FINISH &amp; REVIEW</h5>
                <p>
                  Tap or click Review Your Selection when your perfect stack is
                  complete.
                </p>
                <button
                  className="btn btn-blackrect mt-4 w-100"
                  onClick={onStartStackClick}
                >
                  Start Now
                </button>
              </MediaQuery>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  )
}

export default IntroCarousel
